const KEY_ACCOUNT = '_b2bacn'
const KEY_ACCESS_TOKEN = '_b2buat'
const KEY_MASTER_ACCOUNT_CONNECTED = '_b2bmac'
const KEY_SERVICE_CONNECTIONS = '_b2bScn'

const getAccountStorage = ()=>{
    const account = localStorage.getItem(KEY_ACCOUNT)
    return account ? JSON.parse(account) : null
}

const setAccountStorage = account=>{
    localStorage.setItem(KEY_ACCOUNT, account ? JSON.stringify(account) : '')
}

const getMasterAccountStorage = ()=>{
    const connected = localStorage.getItem(KEY_MASTER_ACCOUNT_CONNECTED)
    return connected === 'yes'
}

const setMasterAccountStorage = connected => {
    localStorage.setItem(KEY_MASTER_ACCOUNT_CONNECTED, connected ? 'yes' : 'no')
}

const getServiceConnections = () => {
    const data = localStorage.getItem(KEY_SERVICE_CONNECTIONS)
    return data ? JSON.parse(data) : null
}

const setServiceConnections = data => {
    localStorage.setItem(KEY_SERVICE_CONNECTIONS, data ? JSON.stringify(data) : '')
}

const isEmpty = value => {
    return value === null || value === ''
}

export default {
    namespaced: true,
    state: {
        account: getAccountStorage(),
        accessToken: localStorage.getItem(KEY_ACCESS_TOKEN),
        masterAccountConnected: getMasterAccountStorage(),
        serviceConnections: getServiceConnections(),
    },
    getters: {
        getAccount: state => state.account,
        getAccessToken: state => state.accessToken,
        isAuthenticated: state => !isEmpty(state.accessToken) && !isEmpty(state.account),
        isMasterAccountConnected: state => state.masterAccountConnected === true,
        getServiceConnections: state => state.serviceConnections,
    },
    actions: {
        setAccount({commit}, account) {
            commit('SET_ACCOUNT', account)
        },
        setAccessToken({commit}, token) {
            commit('SET_ACCESS_TOKEN', token)
        },
        setMasterAccountConnected({commit}, connected) {
            commit('SET_MASTER_ACCOUNT_CONNECTED', connected)
        },
        setUser({commit}, data) {
            commit('SET_USER', data)
        },
        removeUser({commit}) {
            commit('REMOVE_USER')
        },
    },
    mutations: {
        SET_ACCOUNT(state, account) {
            state.account = account
            setAccountStorage(account)
        },
        SET_ACCESS_TOKEN(state, token) {
            state.accessToken = token
            localStorage.setItem(KEY_ACCESS_TOKEN, token || '')
        },
        SET_MASTER_ACCOUNT_CONNECTED(state, connected) {
            state.masterAccountConnected = connected === true
            setMasterAccountStorage(connected)
        },
        SET_USER(state, data) {
            state.account = data?.account || null
            state.accessToken = data?.token || null
            state.masterAccountConnected = data?.masterAccountConnected || false
            state.serviceConnections = data?.serviceConnections || null

            setAccountStorage(state.account)
            setMasterAccountStorage(state.masterAccountConnected)
            localStorage.setItem(KEY_ACCESS_TOKEN, state.accessToken || '')
            setServiceConnections(state.serviceConnections)
        },
        REMOVE_USER(state) {
            state.account = null
            state.accessToken = null
            state.masterAccountConnected = false
            state.serviceConnections = null

            localStorage.removeItem(KEY_ACCOUNT)
            localStorage.removeItem(KEY_ACCESS_TOKEN)
            localStorage.removeItem(KEY_MASTER_ACCOUNT_CONNECTED)
            localStorage.removeItem(KEY_SERVICE_CONNECTIONS)
        }
    }
}